////
/// ============================================================================
/// COMPONENT / Anchor Link
/// ============================================================================
///
/// Utilizzato nelle pagine delle landing, aggiunge la classe .menu-anchor alle
/// voci di menu che contengono un'ancora.
/// @link https://www.yogaformazione2.test/landing-google/
///
/// @group components
////

export default () => {
    const menuLinks = document.querySelectorAll(".ct-menu-link");

    menuLinks.forEach(link => {
        link.addEventListener("click", () => {
            menuLinks.forEach(link => link.classList.remove("-active"));
            link.classList.add("-active");
        });
    });
};
